import _ from 'underscore';
import {
  createRequestContract,
  createResponseContract,

  requestVerbs,
  responseTypes,
} from '@bingads-webui-react/overreact';

import { edm } from '../../../environment/edm';
import { schema } from '../../../environment/schema';
import { getDefaultHeaderObj } from '../../../request-contract-helper';

function odataUrlFactory(params) {
  const { variables } = params;

  const {
    locator,
  } = variables;
  const { descriptor } = locator;
  const { cid, aid, businessId } = descriptor;

  const entity = edm
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Businesses.$withKey(businessId || '');

  return entity.path;
}

function odataHeaderFactory() {
  return getDefaultHeaderObj();
}

function processor(response) {
  return _.omit(response, '@odata.context');
}

export const fetchRequestContract = createRequestContract({
  schema,
  dataPath: 'customer:account:business',
  verb: requestVerbs.GET,
  uriFactoryFn: odataUrlFactory,
  headerFactoryFn: odataHeaderFactory,
  keySelector: business => business.Id,
  parentKeySelector: variables => variables.locator.descriptor.aid,
});

export const fetchResponseContract = createResponseContract({
  requestContract: fetchRequestContract,
  responseType: responseTypes.ENTITY,
  keySelector: business => business.Id,
  processorFn: processor,
});
